import React from 'react';

function NoAppointment() {
    return (
        <div className="appointments-empty">
            <span className="ecx-page-icon-badge mb-3">
                <i className="bi bi-calendar-x" />
            </span>
            <h5 className="appointments-empty__title">No Appointments Found</h5>
            <p className="appointments-empty__text">
                There are no appointments booked for the selected date and filters.
            </p>
        </div>
    );
}

export default NoAppointment;
